import { apiGet } from "./api";

/**
 * Safe API wrapper that never throws
 * Returns fallback values if backend is incomplete
 */
export async function safeGet<T = unknown[]>(fn: () => Promise<unknown>, fallback: T = [] as T): Promise<T> {
  try {
    const res = await fn();
    return (Array.isArray(res) ? res : fallback) as T;
  } catch (e) {
    console.warn("API call failed, using fallback", e);
    return fallback;
  }
}

export async function safeGetInventory(): Promise<unknown[]> {
  return safeGet(() => apiGet("/api/manager/inventory"), []);
}

export async function safeGetSuppliers(): Promise<unknown[]> {
  return safeGet(() => apiGet("/api/manager/suppliers"), []);
}

export async function safeGetSupplierAgeing(): Promise<unknown[]> {
  return safeGet(() => apiGet("/api/manager/supplier-ageing"), []);
}
